//#region import
import React, { Fragment, createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { FnAxios, FnDialog, I18n, ParseHtml } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Grid, Typography } from '@mui/material';
import { BtnCancel, BtnDraft, BtnEdit, BtnSend, BtnSendRequest } from 'components/Button/ButtonAll';
import FroalaEditor from 'react-froala-wysiwyg';
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/plugins.pkgd.min.js";
import 'froala-editor/js/languages/th';
import AccordionPanel from '../components/AccordionPanel';
import { useLocation } from 'react-router';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import ContentWrapper from '../components/ContentWrapper';
//#endregion

const Panel1 = () => {
    const {
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);
    const [sPrincipleEnvironment, setsPrincipleEnvironment] = useState(null);   
    const [sPrincipleBackground, setsPrincipleBackground] = useState(null);       
    const [sPrincipleProblem, setsPrincipleProblem] = useState(null);       
    const [sPrincipleReason, setsPrincipleReason] = useState(null);   

    const ref_sPrincipleEnvironment = useRef<any>(null);
    const ref_sPrincipleBackground = useRef<any>(null);
    const ref_sPrincipleProblem = useRef<any>(null);
    const ref_sPrincipleReason = useRef<any>(null);

    const configs = (placeholderText) => {
        let ObjConfigs = {
            key: "0BA3jA11B5C7C4A4D3aIVLEABVAYFKc2Cb1MYGH1g1NYVMiG5G4E3C3A1C8A6D4A3B4==",
            attribution: false,
            heightMin: 200,
            heightMax: 2000,
            imageUploadURL: process.env.REACT_APP_API_URL + "api/UploadFile/UploadFileFroala",
            // quickInsertButtons: ['image', 'table', 'ol', 'ul', 'myButton'],
            // pluginsEnabled: ['quickInsert', 'image', 'table', 'lists'],
            placeholderText: placeholderText,
            language: 'th',
            // tooltips: false,
            toolbarButtons: {
                moreText: {
                    // buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
                    buttons: ['bold', 'italic', 'underline', 'subscript', 'superscript', 'fontSize', 'textColor', 'clearFormatting']
                },
                moreParagraph: {
                    // buttons: ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
                    buttons: ['alignLeft', 'alignCenter', 'alignRight', 'alignJustify'],
                    buttonsVisible: 4
                },
                moreRich: {
                    // buttons: ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR']
                    // buttons: ['insertTable', 'insertImage', 'insertLink', 'fontAwesome', 'specialCharacters', 'embedly', 'insertHR']
                    buttons: ['insertTable', 'insertImage', 'insertHR']
                },
                moreMisc: {
                    // buttons: ['undo', 'redo', 'fullscreen', 'print', 'spellChecker', 'selectAll', 'html', 'help'],
                    buttons: ['undo', 'redo', 'fullscreen'],
                    align: 'right',
                    buttonsVisible: 3
                }
            },
            quickInsertButtons: ['table', 'image', 'hr'],
            pasteAllowedStyleProps : ['color'], //'font-size', 
            imageEditButtons: ['imageReplace', 'imageAlign', 'imageCaption', 'imageRemove'],
            charCounterCount: false,

            // pastePlain: true,
        }
        return ObjConfigs;
    };

    useEffect(() => {
        setisEditSecretary(isModeSecretary === true ? false : isPermission);
    }, [isModeSecretary])

    useEffect(() => {
        if (nProjectID !== 0) handleGetFormProjectID();
    }, [nProjectID]);

    const handleGetFormProjectID = () => {
        // DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetFormProjectID_Panel1, { nProjectID : nProjectID }, (result) => {
            // DialogFn.UnBlockUI();
            setnProjectID(result.objResult.nProjectID);
            // setnStatusID(result.objResult.nStatusID);
            setisComplete(result.objResult.isComplete);
            setsPrincipleEnvironment(result.objResult.sPrincipleEnvironment);
            setsPrincipleBackground(result.objResult.sPrincipleBackground);
            setsPrincipleProblem(result.objResult.sPrincipleProblem);  
            setsPrincipleReason(result.objResult.sPrincipleReason); 

            if (ref_sPrincipleEnvironment.current) ref_sPrincipleEnvironment.current.props.onModelChange(result.objResult.sPrincipleEnvironment ?? "");
            if (ref_sPrincipleBackground.current) ref_sPrincipleBackground.current.props.onModelChange(result.objResult.sPrincipleBackground ?? "");
            if (ref_sPrincipleProblem.current) ref_sPrincipleProblem.current.props.onModelChange(result.objResult.sPrincipleProblem ?? "");
            if (ref_sPrincipleReason.current) ref_sPrincipleReason.current.props.onModelChange(result.objResult.sPrincipleReason ?? "");
            
            // TextEditor.current.editor.edit.on(); //คือการเปิดการทำงาน Froala Editor
            // TextEditor.current.editor.edit.off(); //คือการปิดการทำงาน Froala Editor
        });
    };

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        if (nModeID === EnumSaveModeProject.Submit) {
            // let _sPrincipleEnvironment = null;
            // let _sPrincipleBackground = null;
            // let _sPrincipleProblem = null;
            // let _sPrincipleReason = null;

            // if (ref_sPrincipleEnvironment.current) _sPrincipleEnvironment = ref_sPrincipleEnvironment.current.props.model;
            // if (ref_sPrincipleBackground.current) _sPrincipleBackground = ref_sPrincipleBackground.current.props.model;
            // if (ref_sPrincipleProblem.current) _sPrincipleProblem = ref_sPrincipleProblem.current.props.model;
            // if (ref_sPrincipleReason.current) _sPrincipleReason = ref_sPrincipleReason.current.props.model;

            let isWarning = false;
            let sWarning = "กรุณากรอกข้อมูล ในหัวข้อดังต่อไปนี้ <br/>"
            if (sPrincipleEnvironment === null || sPrincipleEnvironment === "") {
                sWarning += "1.1 ลักษณะทางกายภาพ ทรัพยากรธรรมชาติ และสิ่งแวดล้อมในพื้นที่โครงการ <br/>";
                isWarning = true;
            }
            if (sPrincipleBackground === null || sPrincipleBackground === "") {
                sWarning += "1.2 ความเป็นมาพื้นฐานของการดําเนินงานที่ผ่านมาในพื้นที่โครงการ <br/>";
                isWarning = true;
            }
            if (sPrincipleProblem === null || sPrincipleProblem === "") {
                sWarning += "1.3 สภาพปัญหาในพื้นที่โครงการ <br/>";
                isWarning = true;
            }
            if (sPrincipleReason === null || sPrincipleReason === "") {
                sWarning += "1.4 เหตุผลและความจําเป็นที่จะต้องจัดทําโครงการ <br/>";
                isWarning = true;
            }
            if(isWarning) return DialogFn.Warning(sWarning);
        } 
        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPanelID: EnumProjectPanel.Panel1,
            isFastTrack: isFastTrack,

            sPrincipleEnvironment : sPrincipleEnvironment,
            sPrincipleBackground  : sPrincipleBackground,
            sPrincipleProblem : sPrincipleProblem,
            sPrincipleReason : sPrincipleReason,

            sLocation: location.pathname,
        };
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
                        ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent)
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPanel1, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        setnProjectID(result.objResult?.nProjectID);
                        setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                        // setarrisEditPanel({nPanelID: 1, isEdit: false});
                        setisSubmit(isSubmit === true ? false : true);
                        if(isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    //#region Call Froala Editor
    // const CallFroalaEditor1 = useCallback(() => {
    //     return(
    //         <>
    //         {(isEditSecretary === true || (isPermission && isModeSecretary !== true)) ?
    //             <FroalaEditor
    //                 // tag='textarea'
    //                 key={'sPrincipleEnvironment'}
    //                 model={sPrincipleEnvironment}
    //                 onModelChange={setsPrincipleEnvironment}
    //                 config={configs("อธิบายลักษณะความสําคัญของพื้นที่สภาพสังคม สิ่งแวดล้อม พร้อมทั้งข้อมูลและข้อเท็จจริงต่างๆ ที่เกี่ยวข้องกับพื้นที่โครงการโดยสังเขป")}
    //                 // ref={TextEditor}
    //             />
    //             :
    //             <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '1px', borderRadius: '10px', }}>
    //                 <FroalaEditorView model={sPrincipleEnvironment} key={'sPrincipleEnvironment_View'}/>
    //             </ContentWrapper> 
    //         }
    //         </>
    //     );
    // },[isEditSecretary, isPermission, isModeSecretary, sPrincipleEnvironment]);

    // const CallFroalaEditor2 = useCallback(() => {
    //     return(
    //         <>
    //         {(isEditSecretary === true || (isPermission && isModeSecretary !== true)) ?
    //             <FroalaEditor
    //                 key={'sPrincipleBackground'}
    //                 model={sPrincipleBackground}
    //                 onModelChange={setsPrincipleBackground}
    //                 // tag='textarea'
    //                 config={configs("การจัดกิจกรรม / การดําเนินการที่ผ่านมามีอะไรบ้างและผลเป็นอย่างไร")}
    //             />
    //             :
    //             <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '1px', borderRadius: '10px', }}>
    //                 <FroalaEditorView 
    //                     // tag='div'
    //                     key={'sPrincipleBackground_View'}
    //                     model={sPrincipleBackground} 
    //                 />
    //             </ContentWrapper> 
    //         }
    //         </>
    //     );
    // },[isEditSecretary, isPermission, isModeSecretary, sPrincipleBackground]);

    // const CallFroalaEditor3 = useCallback(() => {
    //     return(
    //         <>
    //         {(isEditSecretary === true || (isPermission && isModeSecretary !== true)) ?
    //             <FroalaEditor
    //                 key={'sPrincipleProblem'}
    //                 model={sPrincipleProblem}
    //                 onModelChange={setsPrincipleProblem}
    //                 // tag='textarea'
    //                 config={configs("ระบุปัญหาที่ยังคงเหลืออยู่ ปัญหาที่ต้องเร่งแก้ไขในพื้นที่หรือปัญหาที่คาดว่าจะเกิดและต้องการป้องกันหรือเฝ้าระวังในอนาคต")}
    //             />
    //             :
    //             <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '1px', borderRadius: '10px', }}>
    //                 <FroalaEditorView 
    //                     // tag='div'
    //                     model={sPrincipleProblem} 
    //                     key={'sPrincipleProblem_View'}
    //                 />
    //             </ContentWrapper> 
    //         }
    //         </>
    //     );
    // },[isEditSecretary, isPermission, isModeSecretary, sPrincipleProblem]);

    // const CallFroalaEditor4 = useCallback(() => {
    //     return(
    //         <>
    //         {(isEditSecretary === true || (isPermission && isModeSecretary !== true)) ?
    //             <FroalaEditor
    //                 key={'sPrincipleReason'}
    //                 model={sPrincipleReason}
    //                 onModelChange={setsPrincipleReason}
    //                 // tag='textarea'
    //                 config={configs("ชี้ให้เห็นถึงความสําคัญ / ความเสี่ยงที่จะต้องเร่งดําเนินโครงการ")}
    //             />
    //         :
    //             <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '1px', borderRadius: '10px', }}>
    //                 <FroalaEditorView 
    //                     // tag='div'
    //                     model={sPrincipleReason} 
    //                     key={'sPrincipleReason_View'}
    //                 />
    //             </ContentWrapper> 
    //         }
    //         </>
    //     );
    // },[isEditSecretary, isPermission, isModeSecretary, sPrincipleReason]);
    //#endregion
    
    return (
        <AccordionPanel
            header={"1. หลักการและเหตุผล"}
            isExpanded={true} 
            // SubHeader={}
            color="white"
            bgColor="rgb(102,151,245)"
            background="#5598fc"
            expandIconColor="white"
            borderColor="1px solid #5598fc"
            borderRadius="18px !important"
            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
            SubHeaderStatus={
                (isComplete !== null &&
                    <Chip
                        size="small"
                        label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                        style={{
                            color: "white",
                            backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                            fontSize: "14px"
                        }}
                    />     
                )           
            }
            isDisabled={nProjectID === 0}
        >
            <Grid id={"myDivPanel1"} item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                {/* Subject 1 */}
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item>
                            <Typography variant='body1'>1.1 ลักษณะทางกายภาพ ทรัพยากรธรรมชาติ และสิ่งแวดล้อมในพื้นที่โครงการ</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant='body1' color={'red'}>*</Typography>
                        </Grid>                        
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {(isEditSecretary === true || (isPermission && isModeSecretary !== true)) ?
                            <FroalaEditor
                                // tag='textarea'
                                key={'sPrincipleEnvironment'}
                                model={sPrincipleEnvironment}
                                onModelChange={setsPrincipleEnvironment}
                                config={configs("อธิบายลักษณะความสําคัญของพื้นที่สภาพสังคม สิ่งแวดล้อม พร้อมทั้งข้อมูลและข้อเท็จจริงต่างๆ ที่เกี่ยวข้องกับพื้นที่โครงการโดยสังเขป")}
                                ref={ref_sPrincipleEnvironment}
                            />
                            :
                            <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '1px', borderRadius: '10px', }}>
                                <FroalaEditorView model={sPrincipleEnvironment} key={'sPrincipleEnvironment_View'}/>
                            </ContentWrapper> 
                        }
                        {/* <CallFroalaEditor1 /> */}
                    </Grid>
                </Grid>
                {/* Subject 2 */}
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item>
                            <Typography variant='body1'>1.2 ความเป็นมาพื้นฐานของการดําเนินงานที่ผ่านมาในพื้นที่โครงการ</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant='body1' color={'red'}>*</Typography>
                        </Grid>                        
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {(isEditSecretary === true || (isPermission && isModeSecretary !== true)) ?
                            <FroalaEditor
                                key={'sPrincipleBackground'}
                                model={sPrincipleBackground}
                                onModelChange={setsPrincipleBackground}
                                // tag='textarea'
                                config={configs("การจัดกิจกรรม / การดําเนินการที่ผ่านมามีอะไรบ้างและผลเป็นอย่างไร")}
                                ref={ref_sPrincipleBackground}
                            />
                            :
                            <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '1px', borderRadius: '10px', }}>
                                <FroalaEditorView 
                                    // tag='div'
                                    key={'sPrincipleBackground_View'}
                                    model={sPrincipleBackground} 
                                />
                            </ContentWrapper> 
                        }
                        {/* <CallFroalaEditor2 /> */}
                    </Grid>
                </Grid>
                {/* Subject 3 */}
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item>
                            <Typography variant='body1'>1.3 สภาพปัญหาในพื้นที่โครงการ</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant='body1' color={'red'}>*</Typography>
                        </Grid>                        
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {(isEditSecretary === true || (isPermission && isModeSecretary !== true)) ?
                            <FroalaEditor
                                key={'sPrincipleProblem'}
                                model={sPrincipleProblem}
                                onModelChange={setsPrincipleProblem}
                                // tag='textarea'
                                config={configs("ระบุปัญหาที่ยังคงเหลืออยู่ ปัญหาที่ต้องเร่งแก้ไขในพื้นที่หรือปัญหาที่คาดว่าจะเกิดและต้องการป้องกันหรือเฝ้าระวังในอนาคต")}
                                ref={ref_sPrincipleProblem}
                            />
                            :
                            <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '1px', borderRadius: '10px', }}>
                                <FroalaEditorView 
                                    // tag='div'
                                    model={sPrincipleProblem} 
                                    key={'sPrincipleProblem_View'}
                                />
                            </ContentWrapper> 
                        }
                        {/* <CallFroalaEditor3/> */}
                    </Grid>
                </Grid>
                {/* Subject 4 */}
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item>
                            <Typography variant='body1'>1.4 เหตุผลและความจําเป็นที่จะต้องจัดทําโครงการ</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant='body1' color={'red'}>*</Typography>
                        </Grid>                        
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {(isEditSecretary === true || (isPermission && isModeSecretary !== true)) ?
                            <FroalaEditor
                                key={'sPrincipleReason'}
                                model={sPrincipleReason}
                                onModelChange={setsPrincipleReason}
                                // tag='textarea'
                                config={configs("ชี้ให้เห็นถึงความสําคัญ / ความเสี่ยงที่จะต้องเร่งดําเนินโครงการ")}
                                ref={ref_sPrincipleReason}
                            />
                        :
                            <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '1px', borderRadius: '10px', }}>
                                <FroalaEditorView 
                                    // tag='div'
                                    model={sPrincipleReason} 
                                    key={'sPrincipleReason_View'}
                                />
                            </ContentWrapper> 
                        }
                        {/* <CallFroalaEditor4/> */}
                    </Grid>
                </Grid>
            </Grid>
            {nProjectID === 0 || nStatusID === EnumProjectStatusID.nStatusID_11 ?
                <></>
                :
                (isPermission === true &&
                    (isModeSecretary !== true ?
                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                            {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                <Grid item>
                                    <BtnDraft id={"btnDraft_Panel1"} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                </Grid> 
                            }
                            <Grid item>
                                <BtnSendRequest id={"btnSend_Panel1"} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={(e) => {handleSubmit(EnumSaveModeProject.Submit) }} />
                            </Grid> 
                        </Grid>            
                    : 
                        (isModeSecretary === true ?
                            <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                {isEditSecretary === false ?
                                    <Grid item>
                                        <BtnEdit id={"btnEdit_Panel1"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivPanel1").scrollIntoView({ behavior: "smooth" });}} />
                                    </Grid>
                                    :
                                    <>
                                        <Grid item>
                                            <BtnCancel id={"btnCancel_Panel1"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); handleGetFormProjectID(); }} />
                                        </Grid>
                                        <Grid item>
                                            <BtnSendRequest id={"btnSend_Panel1"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit); }} />
                                        </Grid>
                                    </>
                                }   
                            </Grid>
                            : <></>
                        )
                    )
                )
            }
        </AccordionPanel>
    )
}
export default Panel1;
